let VandalismCharacters = [
  {
    characterName: 'Bishop',
    gender: '♂',
    height: 174,
    position: "행정관리부 부장, 인사팀 팀장, 헤드헌터",
    description: ["채용과 인사고과 등을 담당중인 헤드헌터. 본인 말로는 남의 몸에 기생하고 있는 거라고 한다. ",
        "부담스럽게 퍼스널 스페이스를 무시하고 훅 들어와서 장광설을 늘어놓더니 ",
        "정신 차려보니 짠! 당신은 수상한 연구소에 채용되어 있었습니다. 그 원흉 되시겠다. ",
        "시끄럽고 정신없다. 상식적으로 이해 안 될 행동만 하고 있다. ",
        "섹슈얼한 끌림을 느끼는 대상: 전기톱과 시체와 SM과 그리고 당신."
    ],
    imageOffset: {x: 0, y: 0}
  },
  {
    characterName: 'Dmitri',
    gender: '♂',
    height: 184,
    position: "보안팀 사원, 특무부대 대장. 본명 드미트리 코스토글로토프. 애칭 미챠.",
    description: ["지하 담당 경비원. 사실 경비 정도가 아니라 침입자 제압, 소동 진압 등 ",
        "무력 쓰는 일이라면 이곳저곳 다 불려다닌다. ",
        "아주 뻔한 '험하게 생겼는데 사실 따듯하고 트라우마가 있고 뭐시기뭐시기 군인. ",
        "고양이가 귀엽고 단 게 맛있고 타이타닉 보면서 우는 게 뭐가 어때서! ",
        "난민 출신에 전직 군인으로, 극단적인 상황이 되면 방어기제로 일단 마구 날뛰고 본다. ",
        "그런 점을 회사에 이용당하고 있다."
    ],
    imageOffset: {x: 0, y: 0}
  },
  {
    characterName: 'Haze',
    gender: '♀',
    height: 163,
    position: "행정팀 팀장, 시설관리본부장",
    description: ["원래 연구직이었으나 크게 사고를 쳐서 사무직으로 좌천당했다. ",
        "성격이 더럽고 싹바가지 없다. 그래서 친구도 없다. 적만 한가득하다. ",
        "별의 별 스포츠랑 악기에 만능이고, 예술에 조예가 깊은 등 다재다능하지만 ",
        "금방 흥미를 잃고 지겨워한다. 요즘 취미는 사진이랑 캠핑. ",
        "허구한날 담배만 뻑뻑 피워댄다. 그 돈으로 페라리를 한대 뽑았겠구만, 이라고 하면 ",
        "실제로 뽑은 자기 외제차를 재수없게 자랑해댄다."
    ],
    imageOffset: {x: 0, y: 0}
  },
  {
    characterName: 'Professor',
    gender: '♀',
    height: 164,
    position: "직속 대학 교수, 직원 연수 담당자",
    description: ["연구소 직결 대학원의 담당교수. 불쌍한 대학원생을 연구소로 끌어들이고 있다. ",
        "연구소의 기술을 신입에게 교육하고 있으며, 그 일 외에는 대체로 대학에서 지내는데, ",
        "이건 그냥 위험한 데 말려들고 싶지 않아서 그렇다. 약았다. ",
        "정신연령이 자기 딸이랑 똑같고, 누군가 뭘 던지면 달려가서 주워오고 싶고, ",
        "반찬에 고기가 없다고 투정하고, 최소한의 물건으로 최대한 사무실을 더럽히고, ",
        "주말이면 가족들한테 산책당하는 등 그냥 개."
    ],
    imageOffset: {x: -25, y: 0}
  },
  {
    characterName: 'Ivan',
    gender: '로봇이라 딱히 없음!',
    height: 155,
    position: "부속 병동 내과의사. 사이보그.",
    description: ["병원 상주 전기 고양이. 손님 없으면 이곳저곳 들쑤시며 노는 게 일과다. ",
        "이녀석과 놀고 있으면 피톤치드 효과로 기분이 좋아지고 혈당치가 억제되며 ",
        "코어근육이 강화되고 조상신의 가호를 받아 재앙신의 다음 제물 후보를 면하게 된다. ",
        "자기는 사람들이 왜 지나가면서 자신을 쓰다듬고 찔러보고 가는지 잘 모르겠다. ",
        "사이보그라 기술 유출 방지를 위해 외출금지를 당하고 있지만, 히키코모리라 괜찮다."
    ],
    imageOffset: {x: 0, y: -50}
  },
  {
    characterName: 'Wei',
    gender: '♀',
    height: 165,
    position: "행정팀 사원, 헤이즈의 조수. 액신.",
    description: ["연구직이었는데 세상을 멸망시킬뻔한 87번의 사고 끝에 부서를 이전당했다. ",
    "대체로 재앙신이고, 태어날 때 액막음을 한다는 걸 액을 모아버린 바람에 세상에 강림하고 말았다. ",
    "새해에 맛있는 걸 사주고 소원을 빌면 그 해의 액땜을 할 수 있다. ",
    "...라는 소문만 무성한 인물. ",
    "경찰 옷을 입고 있는 이유는 외근 나갈 때 신분 위장을 위해. 라고 하지만 사실 ",
    "입고 있으면 남이 피해서 사고에 휘말릴 확률이 낮아지니까."
    ],
    imageOffset: {x: 0, y: 0}
  },
  {
    characterName: 'Surgeon',
    gender: '♂',
    height: 175,
    position: "부속 병동 의료진 대표, 외과의사",
    description: [ "복잡한 수술이 필요하다면 어디든 불려다니는 유능한 의사선생. ",
        "뇌 이식부터 인체실험이랑 장기매매까지 척척 해낸다. 인체개조에 흥분한다. ",
        "몸이 10개라도 부족할 지경이라 인간의 육체에 한계를 느끼고 있다. ",
        "그래서 일단 눈부터 4개로 바꿔봤는데 괜찮은 것 같다. 팔도 늘릴까 싶다. ",
        "심각한 불면증. 밤마다 벽에 머리 박는다."
    ],
    imageOffset: {x: -10, y: 0}
  },
  {
    characterName: 'Rondo',
    gender: '♀?',
    height: 180,
    position: "전무이사",
    description: ["사장 따까리. 직원과 이사진 사이의 일을 조율하고 있다. 아니 사실 양측을 감시하고 있다. ",
        "적당히 건물 내를 돌아다니며 아무데나 말 걸고 다니는 상냥한 높으신 분. ",
        "간식으로 눈알 통조림을 꺼내 먹는다거나 가방에 먹이를 준다거나 하긴 하지만. ",
        "\"위대하신 그분\"과는 사이 좋은 친구. 인간 살코기는 민들레와 피의 세계의 것. ",
        "매사에 긍정적이려 노력한 결과 세상만사 모든 것이 아무래도 좋아졌다."
    ],
    imageOffset: {x: 25, y: 0}
  },
  {
    characterName: 'Alexey',
    gender: '♂',
    height: 173,
    position: "연구2팀 신입사원. 주인공.",
    description: ["어... 안녕하세요! 이건 제가 쓰라고 하길래, 몇줄 써볼게요. ",
        "얼마 전에 입사한 알렉세이예요! 그러니까 저는 이 세계의 주인공?이고... ",
        "이게 아마 게임이 될 거라는 건 알고 있고... 대충 그래요! ",
        "주인공을 맡는 게 처음은 아니지만, 이번에도 살아남고 싶네요. ",
        "작가라는 족속들은 사람 죽이기를 좋아하니까요. 하하..."
    ],
    imageOffset: {x: 25, y: -10}
  },
  {
    characterName: 'Necro',
    gender: '♂',
    height: "측정 거부",
    position: "법의학과 과장 (또는 부검팀 팀장)",
    description: ["연구소에서 생기는 별의별 변사체를 연구하고 있는 부검의. 생긴 게 딱 꼬맹이. ",
        "법의학의 길을 택한 이유는 단순히 드라마 NCIS를 보다가 거기 나오는 부검의를 동경하게 돼서. ",
        "좋아하는 것은 호러 추리 소설과 호러 영화와 검은색과 고스 패션과 데스메탈. ",
        "발이 넓고, 정보통이지만, 그게 오히려 독이 되어서 괜한 일에 많이 휘말리고 있다. ",
        "그래도 괜찮다! 언제나 주머니에 풀 장전된 UZI가 있으니까! 난 윤회전생을 믿으니까!"
    ],
    imageOffset: {x: 0, y: -100}
  },
  {
    characterName: 'Miranda',
    gender: '♀',
    height: 160,
    position: "연구1팀 사원, 최모씨 직속 조수.",
    description: ["폭발과 불과 아이스크림과 중화기를 사랑하는 대리급 연구원. ",
    "일중독에, 성공에 목매고 있다. 완벽주의에 성과주의자라 일을 매번 늘려온다. ",
    "그래서 아무도 시키지 않은 야근과 철야에 묶여있다. ",
    "하지만 이 성과주의 사회는 간악한 부르주아 놈들의 착취와 계략 때문이라고!!! ",
    "정의를 바로잡는 것은 바로 우리다!!! 약자의 편에 필요한 건 AK-47과 RPG-7!!!"
    ],
    imageOffset: {x: 0, y: -50}
  },
  {
    characterName: 'Kumo',
    gender: '♂',
    height: 171,
    position: "보안팀 팀장, 지하기지담당자???",
    description: ["'위험하다. 지상에서 마주치면 보안팀에 연락할 것. 지하에서 마주치면 도망가라. ",
        "초대한다면 거절해라. 음식을 준다면 버려라. 정보를 준다면 믿지 마라.' ",
        "지하에 아예 사는 것 같고, 진행중인 극비 실험 여럿에 관여하고 있는 인간. ",
        "이녀석이 지하를 관리감독하는 건지, 이녀석 때문에 지하를 격리해둔 건지 알 수 없다. ",
        "하는 말의 대부분이 거짓말. 목표는 세계정복. 좋아하는 곤충은 지네."
    ],
    imageOffset: {x: 0, y: 10}
  },
  {
    characterName: 'Ilya',
    gender: '?',
    height: 178,
    position: "법의학과 사원. 부검의의 조수.",
    description: ["시체 처리 전문가. 부검이 아니라 \"손질\"을 하는 것 같다. 산 사람을 잡아먹을 순 없잖아. ",
        "무슨 일이든 방관주의에, 과묵하고, 시키는 일에 의문도 갖지 않는다. ",
        "그래서 벌써부터 앞잡이라느니 흉흉한 소문이 돌지만 신경쓰지 않는다. ",
        "일은 일이라서 퇴근 후에는 연락두절이 되어 자기 삶으로 사라진다. ",
        "그러면서 뭘 하는지는 불명...이라지만, 사실 음악을 만들거나 게임을 하고 있다."
    ],
    imageOffset: {x: 0, y: 0}
  },
  {
    characterName: 'Wondertain',
    gender: '♀',
    height: 157,
    position: "감사팀 사원?",
    description: ["언제부터 여기 있었는지, 정확하게 어디 소속인지 아무도 모르는 사람. ",
        "신출귀몰, 모두의 비밀과 사생활을 알고 있다. 그걸 악의적으로 이용해 약점을 잡는다. ",
        "정보를 모아 이사로 승진해, 권력을 거머쥐고 싶다. 그걸로 남을 깔보고 싶다!!! ",
        "뭐 그런 컨셉. 신비주의를 밀고 싶은데, 다들 자신을 너무 안 무서워해서 짜증난다. ",
        "원래는 패션계에서 일했고, 조금이라도 흐트러진 모습을 보이고 싶지 않아한다.",
    ],
    imageOffset: {x: -10, y: -10}
  },
  {
    characterName: 'Agatha',
    gender: '♀',
    height: 168,
    position: "연구2팀 팀장",
    description: ["약과 파티와 BL만화와 트위터를 삶의 낙으로 삼고 있는 월급쟁이 연구원. ",
        "이 회사 사람들이 다 그렇듯 머리가 돌아있다. 그래도 정상적인 축. ",
        "목표는 더 쩔어주는 약 개발! 이거라면 뇌를 속여서 우울증도 삭제! ",
        "....신임도 두텁고 사람도 좋지만, 왜 이런 데서 일하고 있는지 알 것 같다. ",
        "약을 안 하면 극히 차분하고 조용해진다. 거의 다른 사람 수준."
    ],
    imageOffset: {x: 25, y: 0}
  },
  {
    characterName: 'Rebecca',
    gender: '♀',
    height: 186,
    position: "인사팀 사원, 부장님의 조수.",
    description: ["잘생겼다. 친절하다. 어디 영화에 나와도 손색이 없다. ",
        "모두가 감탄하며 바라보지만, 사실 내성적이라 부끄러워 죽겠다. ",
        "막상 친해져보면 귀여운 캐릭터들이 죽고 죽이는 애니메이션을 그린다거나 ",
        "하루에 하리보 구미베어를 2봉지씩 먹는다거나, 심즈에서 인간을 가둬놓고 불지르고 있다. ",
        "전에는 모델 일을 했었고, 원더테인과 함께 사고에 휘말려 여기 발이 묶였다."
    ],
    imageOffset: {x: 10, y: 0}
  },
  {
    characterName: 'Therapist',
    gender: '♂',
    height: 176,
    position: "전직 이사, 현 정신과의",
    description: ["회사 직원들의 정신건강을 책임지고 있는 의사. 도움이 안 된다. ",
        "자기부터가 정신병을 5개정도 갖고있다. 다들 일단 무서워한다. ",
        "책장에 책이 무지개색으로 정렬되어있지 않다면 세상이 멸망할 것이다. ",
        "자고 일어나서 슬리퍼를 왼쪽부터 신으면 땅이 갈라지고 말 것이다!!! ",
        "그래도 모두가 행복했으면 좋겠는 건 진심이다. 그러니까 나랑 친구하자?"
    ],
    imageOffset: {x: 15, y: 0}
  },
  {
    characterName: 'Demian',
    gender: '♂',
    height: 178,
    position: "이사.",
    description: ["회사의 정보 및 보안을 책임지고 있는 이사님. 그러니까, 사람들 입 틀어막는 게 일이다. ",
        "언제나 싱글벙글 웃으면서 친절하게 다가오지만 수틀리면 뭐든 저지른다. ",
        "폭력에 거부감이 없고, 오히려 좋아하고, 사실 남을 해치는 게 즐겁다. ",
        "성공과 권력에 눈이 멀었다. 취미가 없다. 자기 삶이 없다. 친구도 없다. ",
        "커피 광인. 카페인이라면 뭐든 좋다. 다 마시고 컵을 부숴버리는 게 좋다."
    ],
    imageOffset: {x: 0, y: 0}
  },
  {
    characterName: 'SAZANG',
    gender: '♂',
    height: 172,
    position: "사장.",
    description: ["회사의 모든 일을 총괄하는 지배자. 아직은 인간이다, 아마. ",
        "항상 바쁘게 돌아다니고, 표정이 썩어있고, 뭔가 순간이동을 하는 것 같고, ",
        "당신의 일거수일투족을 다 알고 있고, 얼굴이 어쩐지 안 보이지만, ",
        "멀쩡하게 술과 아이스크림과 사람 죽이는 걸 좋아하는 아저씨다. ",
        "고참 직원 모 씨曰 \"예전엔 좀 더 옆집 할아버지 같았는데. 변했다. 슬프다.\""
    ],
    imageOffset: {x: -25, y: 0}
  },
  {
    characterName: 'Choi',
    gender: '♂',
    height: 177,
    position: "연구부서 총책임자, 연구1팀 팀장",
    description: ["회사의 대부분의 프로젝트를 관리 감독하고 있는 인간. 인간? ",
        "무슨 일이 일어나도 냉정하고, 동요하지 않고, 표정 하나 안 변하고, 반응이 없다. ",
        "개인사도 사생활도 불명. 오로지 일만 하고, 사람도 사귀지 않는다. ",
        "유능하고 입도 무거워서 윗사람들에겐 신뢰받지만 아랫사람들에겐 공포의 대상. ",
        "조수인 미란다 씨의 말에 따르면, 사실 고양이를 기르고 있다."
    ],
    imageOffset: {x: 0, y: 0}
  },
];

export default VandalismCharacters;